export const userData = [
   {
     name: 'Jan',
     "Active User": 4000,
   },
   {
     name: 'Fab',
     "Active User": 5000,
   },
   {
     name: 'Mar',
     "Active User": 3000,
   },
   {
     name: 'Apr',
     "Active User": 4000,
   },
   {
     name: 'May',
     "Active User": 2000,
   },
   {
     name: 'Jun',
     "Active User": 3000,
   },
   {
     name: 'Jul',
     "Active User": 1000,
   },
   {
     name: 'Aug',
     "Active User": 2000,
   },
   {
     name: 'Sep',
     "Active User": 1000,
   },
   {
     name: 'Oct',
     "Active User": 4000,
   },
   {
     name: 'Nov',
     "Active User": 2000,
   },
   {
     name: 'Dec',
     "Active User": 3000,
   },
];

export const productData = [
  {
    name: 'Jan',
    "Sales": 4000,
  },
  {
    name: 'Fab',
    "Sales": 2000,
  },
  {
    name: 'Mar',
    "Sales": 3000,
  },
];

export const userRows = [
  { 
    id: 1, 
    username: 'Jon Snow', 
    avator: 'https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500', 
    email: 'jonSnow@gmail.com', 
    status: 'active', 
    transaction: '$120.00'
  },
  { 
    id: 2, 
    username: 'Anna Becker', 
    avator: 'https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500', 
    email: 'annabeck99@gmail.com', 
    status: 'active', 
    transaction: '$150.00'
  },
  { 
    id: 3, 
    username: 'De Kock', 
    avator: 'https://images.pexels.com/photos/3863793/pexels-photo-3863793.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500', 
    email: 'dekock@gmail.com', 
    status: 'active', 
    transaction: '$70.00'
  },
  { 
    id: 4,
    username: 'Thor Thunder',
    avator: 'https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500', 
    email: 'thor@gmail.com', 
    status: 'active', 
    transaction: '$1000'
  },
  { 
    id: 5, 
    username: 'Anna Keller', 
    avator: 'https://images.pexels.com/photos/428321/pexels-photo-428321.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500', 
    email: 'annakeller@gmail.com', 
    status: 'active', 
    transaction: '$100.00'
  },
  { 
    id: 6, 
    username: 'Tonny Stark', 
    avator: 'https://images.pexels.com/photos/1680172/pexels-photo-1680172.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500', 
    email: 'tonnystark@gmail.com', 
    status: 'active', 
    transaction: '$700.00'
  },
  
  { 
    id: 7, 
    username: 'Ayaana Marvel', 
    avator: 'https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500', 
    email: 'marvel@gmail.com', 
    status: 'active', 
    transaction: '$190.00'
  },
  { 
    id: 8, 
    username: 'Spider Man', 
    avator: 'https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500', 
    email: 'spiderman@gmail.com', 
    status: 'active', 
    transaction: '$500.00'
  },
  { 
    id: 9, 
    username: 'William ju', 
    avator: 'https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500', 
    email: 'william@gmail.com', 
    status: 'active', 
    transaction: '$20.00'
  },
  { 
    id: 10, 
    username: 'John Doe', 
    avator: 'https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500', 
    email: 'johnDoe@gmail.com', 
    status: 'active', 
    transaction: '$170.00'
  },
];


export const productRows = [
  { 
    id: 1, 
    name: 'Apple Airpods', 
    img: 'https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500', 
    stock: 123, 
    status: 'active', 
    price: '$120.00'
  },
  { 
    id: 2, 
    name: 'Apple Airpods', 
    img: 'https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500', 
    stock: 123, 
    status: 'active', 
    price: '$120.00'
  },
  { 
    id: 3, 
    name: 'Apple Airpods', 
    img: 'https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500', 
    stock: 123, 
    status: 'active', 
    price: '$120.00'
  },
  { 
    id: 4, 
    name: 'Apple Airpods', 
    img: 'https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500', 
    stock: 123, 
    status: 'active', 
    price: '$120.00'
  },
  { 
    id: 5, 
    name: 'Apple Airpods', 
    img: 'https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500', 
    stock: 123, 
    status: 'active', 
    price: '$120.00'
  },
  { 
    id: 6, 
    name: 'Apple Airpods', 
    img: 'https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500', 
    stock: 123, 
    status: 'active', 
    price: '$120.00'
  },
  { 
    id: 7, 
    name: 'Apple Airpods', 
    img: 'https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500', 
    stock: 123, 
    status: 'active', 
    price: '$120.00'
  },
  { 
    id: 8, 
    name: 'Apple Airpods', 
    img: 'https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500', 
    stock: 123, 
    status: 'active', 
    price: '$120.00'
  },
  { 
    id: 9, 
    name: 'Apple Airpods', 
    img: 'https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500', 
    stock: 123, 
    status: 'active', 
    price: '$120.00'
  },
  { 
    id: 10,
    name: 'Apple Airpods',
    img: 'https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500', 
    stock: 123,
    status: 'active', 
    price: '$120.00'
  },
];